export const ISS_OPTIONS = [
  { value: 0, label: "Não definido" },
  { value: 1, label: "Isento de ISS" },
  { value: 2, label: "Imune" },
  { value: 3, label: "Não Incidência no Município" },
  { value: 4, label: "Não Tributável" },
  { value: 5, label: "Retido" },
  { value: 6, label: "Tributável Dentro do Município" },
  { value: 7, label: "Tributável Fora do Município" },
  { value: 8, label: "Tributável Dentro do Município pelo tomador" }
];

export const PIS_COFINS_OPTIONS = [
  { value: "00", label: "Nenhum" },
  { value: "01", label: "Operação Tributável com Alíquota Básica" },
  { value: "02", label: "Operação Tributável com Alíquota Diferenciada" },
  { value: "03", label: "Operação Tributável com Alíquota por Unidade de Medida de Produto" },
  { value: "04", label: "Operação Tributável monofásica - Revenda a Alíquota Zero" },
  { value: "05", label: "Operação Tributável por Substituição Tributária" },
  { value: "06", label: "Operação Tributável a Alíquota Zero" },
  { value: "07", label: "Operação Tributável da Contribuição" },
  { value: "08", label: "Operação sem Incidência da Contribuição" },
  { value: "09", label: "Operação com Suspensão da Contribuição" }
];

export const SN_TAX_REGIME_OPTIONS = [
  { value: "none",  label: "Nenhum" },
  { value: "simple_national",  label: "1 - Tributos federais e municipal apurados pelo Simples Nacional" },
  { value: "simple_national_and_issqn",  label: "2 - Tributos federais apurados pelo Simples Nacional e ISSQN apurado pela NFS-e, conforme a legislação municipal" },
  { value: "local",  label: "3 - Tributos federais e municipal apurados pela NFS-e, conforme as legislações federal e municipal" },
]

export const FEDERAL_WITHHOLDING_OPTIONS = [
  { value: "0", label: "PIS/COFINS/CSLL Não Retidos" },
  { value: "3", label: "PIS/COFINS/CSLL Retidos" },
  { value: "4", label: "PIS/COFINS Retidos, CSLL Não Retido" },
  { value: "5", label: "PIS Retido, COFINS/CSLL Não Retidos" },
  { value: "6", label: "COFINS Retido, PIS/CSLL Não Retidos" },
  { value: "7", label: "PIS Não Retido, COFINS/CSLL Retidos" },
  { value: "8", label: "PIS/COFINS Não Retidos, CSLL Retido" },
  { value: "9", label: "COFINS Não Retido, PIS/CSLL Retidos" }
];

export const ISS_TAXATION_MAP = {
  undefined: 0,
  exempt: 1,
  immune: 2,
  non_incidence_municipality: 3,
  non_taxable: 4,
  withheld: 5,
  taxable_within_municipality: 6,
  taxable_outside_municipality: 7,
  taxable_within_municipality_by_taker: 8,
};

export const SN_TAX_REGIME = {
  none: "none",
  simple_national: "simple_national",
  simple_national_and_issqn: "simple_national_and_issqn",
  local: "local"
};

export const NFSE_STATUS_LABEL = {
    pending: "Aguardando retorno",
    done: "Emitida",
    rejected: "Rejeitada",
    interrupted: "Interrompida",
    denied: "Denegada",
    awaiting_cancellation: "Aguardando cancelamento",
    cancelled: "Cancelada",
};